import { graphql } from "react-relay";

export const load_blacklisted_dates = graphql`
  query LoadBlacklistedDatesQuery(
    $startingYear: Int!
    $schoolId: ID
    $first: Int!
    $after: String
  ) {
    ...LoadBlacklistedDates_query_blacklistedDates
      @arguments(startingYear: $startingYear, schoolId: $schoolId, first: $first, after: $after)
  }
`;

export const load_blacklisted_dates_pagination = graphql`
  fragment LoadBlacklistedDates_query_blacklistedDates on Query
  @argumentDefinitions(
    startingYear: { type: "Int!" }
    schoolId: { type: "ID" }
    first: { type: "Int!" }
    after: { type: "String" }
  )
  @refetchable(queryName: "LoadBlacklistedDatesPaginationQuery") {
    blacklistedDates(
      schoolId: $schoolId
      startingYear: $startingYear
      first: $first
      after: $after
    ) @connection(key: "LoadBlacklistedDates_query_blacklistedDates") {
      __id
      edges {
        node {
          id
          date
          reason
          school {
            id
          }
          teachers {
            edges {
              node {
                id
                user {
                  id
                  firstName
                  lastName
                }
              }
            }
          }
        }
      }
    }
  }
`;
